import type { BillingAdditionalData } from "@warrenio/api-spec/spec.oats.gen";
import * as billingSpec from "@warrenio/api-spec/spec/billing";

export interface WithAdditionalData {
    additional_data?: string;
}

export function parseAccountAdditionalData(item: WithAdditionalData) {
    const { additional_data } = item;
    if (!additional_data) {
        return undefined;
    }
    const data = JSON.parse(additional_data) as BillingAdditionalData;
    if (import.meta.env.DEV) {
        // Validate
        billingSpec.BillingAdditionalData.parse(data);
    }
    return data;
}
